/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantDto } from './TenantDto';
import {
    TenantDtoFromJSON,
    TenantDtoFromJSONTyped,
    TenantDtoToJSON,
    TenantDtoToJSONTyped,
} from './TenantDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface TenantListResponse
 */
export interface TenantListResponse {
    /**
     * 
     * @type {string}
     * @memberof TenantListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof TenantListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof TenantListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof TenantListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {Array<TenantDto>}
     * @memberof TenantListResponse
     */
    data?: Array<TenantDto>;
    /**
     * 
     * @type {number}
     * @memberof TenantListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantListResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the TenantListResponse interface.
 */
export function instanceOfTenantListResponse(value: object): value is TenantListResponse {
    return true;
}

export function TenantListResponseFromJSON(json: any): TenantListResponse {
    return TenantListResponseFromJSONTyped(json, false);
}

export function TenantListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TenantDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function TenantListResponseToJSON(json: any): TenantListResponse {
    return TenantListResponseToJSONTyped(json, false);
}

export function TenantListResponseToJSONTyped(value?: TenantListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TenantDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

